import {
  Action,
  NestedAction,
} from '../components/ActionsMenu/ActionsMenu.types';
import { Option } from '../components/Select';
import { NestedOption } from '../components/Select/Select.types';

export function isNested(
  obj: Option | NestedOption | Action | NestedAction
): obj is NestedOption | NestedAction {
  return (
    'subheading' in obj &&
    (Array.isArray((obj as NestedOption).options) ||
      Array.isArray((obj as NestedAction).actions))
  );
}
